module.exports = __webpack_public_path__ + "img/hot_and_fresh_pizza_pizza.f74e81cd.jpg";